import { OrganizationProfile } from '@clerk/clerk-react';

export function TeamTab() {
  return (
    <div>
      <h3 className="mb-4 text-sm font-semibold">Team Members</h3>
      <OrganizationProfile routing="hash" />
    </div>
  );
}
